import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"
import PageSidebarContent from "../../../components/sidebars/PageSidebarContent"

export default function ParticipantReferralLayout(Props) {
  return (
    <>
      <PageSidebarContent>
        <ParticipantSidebar />
      </PageSidebarContent>
      <div>{Props.children}</div>
    </>
  )
}
